import { useCallback, useEffect, useState } from "react";
import tw from "twin.macro";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const PopupProduct = ({ isOpen, setIsOpen, data, dropdownRef }) => {
  const { title, content, image, /*listofImage*/ } = data;
  const img = getImage(image);
const [changeImage, /*setChangeImage*/] = useState(img);

  //const listofImagefull = [image, ...listofImage];

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && isOpen) {
        setIsOpen(false);
      }
    },
    [setIsOpen, isOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  return (
    <div
      css={
        isOpen
          ? tw`fixed  p-5 md:p-20 bg-black min-h-screen h-full bg-opacity-60 w-full top-0 left-0 z-10`
          : tw`hidden`
      }
    >
      <div tw="bg-gray-800  text-white rounded-xl w-full h-full overflow-auto">
        <div tw="flex sticky z-10 top-0 w-full bg-gray-800 justify-between border-b">
          <h1 tw="text-center font-bold p-2 mx-auto">{title}</h1>

          <button
            tw="text-xl px-4 py-1 "
            css={!isOpen && tw`hidden`}
            onClick={() => setIsOpen(false)}
          >
            X
          </button>
        </div>

        <div>
          <div tw="grid md:grid-cols-2 p-5 gap-5">
            <div>
              <GatsbyImage
                tw="rounded-2xl h-auto w-full shadow-2xl"
                image={changeImage}
                alt="profile"
              />
              {/* 
              <div tw="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 mt-3">
                {listofImagefull.map((item, index) => {
                  const img = getImage(item);

                  return (
                    <GatsbyImage
                      onClick={() => setChangeImage(img)}
                      image={img}
                      alt="image"
                      tw="cursor-pointer w-full bg-cover h-20  transition-transform transform duration-300 hover:(    scale-110)"
                      key={index}
                    />
                  );
                })}
              </div> */}
            </div>
            <div tw="p-1 lg:pt-10 space-y-4">
              <p tw="font-medium  text-center text-2xl">{title}</p>
              <div tw="mx-auto max-w-xl">
                <p tw="">{content}</p>
              </div>
              <div tw="mx-auto lg:py-10 flex space-x-5 max-w-2xl">
                <a
                  href={data.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  tw="border-none py-2 w-full text-center  rounded-md bg-red-600 text-white font-medium  hover:bg-red-700 "
                >
                  View Demo
                </a>
                <a
                  href={data.paymentlink}
                  target="_blank"
                  rel="noopener noreferrer"
                  tw="border-none cursor-pointer py-2 w-full text-center rounded-md bg-red-600 text-white font-medium hover:bg-red-700"
                >
                  Buy now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupProduct;
